exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-move[data-v-496dd9d4] {\n    transition: transform .5s ease-in-out;\n}\n.list-enter-active[data-v-496dd9d4], .list-leave-active[data-v-496dd9d4] {\n    transition: all 1s;\n}\n.list-enter[data-v-496dd9d4], .list-leave-to[data-v-496dd9d4] /* .list-leave-active below version 2.1.8 */ {\n    opacity: 0;\n    transform: translateY(30px);\n}\n", ""]);

// exports
